export const IDENTITY_GET_TOKEN_PATH_KEY = '/identity/GetPWDAccessToken';

export const TRANSLATION_PATH_KEY = 'translation';
export const SYSTEM_LANG_CHANGE_PATH_KEY = 'systemlangchange';
export const USER_PATH_KEY = "user";
export const CURRENT_PATH_KEY = "current";
export const SELF_REGISTRATION_PATH_KEY = "selfregistration";
